import { render, staticRenderFns } from "./UploadTeacherEditionModal.vue?vue&type=template&id=739c707a&"
import script from "./UploadTeacherEditionModal.vue?vue&type=script&lang=js&"
export * from "./UploadTeacherEditionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports